export default __webpack_public_path__ + "static/media/sleepingBag.3ff494d0.svg";